



































































































































import Vue from 'vue';
import { createNamespacedHelpers, mapActions as mapRootActions } from 'vuex';
import Checkbox from '../common/form/Checkbox.vue';
import InputText from '../common/form/InputText.vue';
import FormInput from '../common/form/FormInput.vue';
import PaginatedSingleSelect from '../common/form/PaginatedSingleSelect.vue';
import AddressField from '../common/form/AddressField.vue';
import Errors from '../common/form/Errors.vue';
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers('grievanceForm');
import { mapState as mapRootState } from 'vuex';

const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;

export default Vue.extend({
    components: { Errors, PaginatedSingleSelect, FormInput, InputText, Checkbox, AddressField },
    computed: {
        ...mapCustomLabelsState(['emailNoteText']),
        ...mapGetters(['getFieldErrors', 'isFieldVisible', 'getFieldLabel']),
        ...mapState([
            'anonymous',
            'title',
            'firstName',
            'lastName',
            'notification',
            'email',
            'phone',
            'ageGroup',
            'ethnicGroup',
        ]),
        ...mapRootState(['showAnonymousEmailNotification', 'portalBranding']),
        isAddressVisible(): boolean {
            return (
                this.isFieldVisible('addressLine1') ||
                this.isFieldVisible('addressLine2') ||
                this.isFieldVisible('neighborhood') ||
                this.isFieldVisible('sublocality') ||
                this.isFieldVisible('city') ||
                this.isFieldVisible('state') ||
                this.isFieldVisible('country') ||
                this.isFieldVisible('postalCode') ||
                this.isFieldVisible('sublocality2') ||
                this.isFieldVisible('arealevel2')
            );
        },
    },
    methods: {
        ...mapMutations([
            'setAnonymous',
            'setTitle',
            'setFirstName',
            'setLastName',
            'setNotification',
            'setEmail',
            'setPhone',
            'setAgeGroup',
            'setEthnicGroup',
        ]),
        ...mapRootActions(['addError']),
        handleError(error: Error) {
            this.addError({ error });
        },
    },
});
